module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/2-adf67b8ca28b2584cb866246dc7fba77.png";